/*
 * Keeps the cart "Taxe" subsection icons (snippets/cart-tax-summary.liquid) in sync
 * with the Magical Mandatory Fees app.
 *
 * The app stores each fee's icon in its own config (an app-owned metaobject the theme
 * can't read server-side) and re-uploads the file with a new random name whenever it
 * changes — so a hardcoded filename goes stale. This reads the app's live config
 * (the JSON the app embeds in <magical-mandatory-fees>) and sets each
 * .cart-tax-summary__icon[data-fee-title] to the fee's current image, matching by title.
 * Re-applies whenever the cart re-renders.
 */
(function () {
  if (window.__cartTaxIconsInit) return;
  window.__cartTaxIconsInit = true;

  var feesCache = null;

  function getFees() {
    if (feesCache) return feesCache;
    var el = document.querySelector('magical-mandatory-fees script[type="application/json"]');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      if (data && data.fees_metaobjects && data.fees_metaobjects.length) {
        feesCache = data.fees_metaobjects;
        return feesCache;
      }
    } catch (e) {}
    return null;
  }

  function apply() {
    var fees = getFees();
    if (!fees) return;
    var icons = document.querySelectorAll('.cart-tax-summary__icon[data-fee-title]');
    for (var i = 0; i < icons.length; i++) {
      var img = icons[i];
      var title = (img.getAttribute('data-fee-title') || '').trim();
      var url = null;
      for (var j = 0; j < fees.length; j++) {
        var fee = fees[j];
        if (((fee.title || '').trim()) === title && fee.image && fee.image.url) {
          url = fee.image.url;
          break;
        }
      }
      if (!url) continue;
      if (url.indexOf('//') === 0) url = 'https:' + url;
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };
    raf(function () { scheduled = false; apply(); });
  }

  if (document.readyState !== 'loading') apply();
  else document.addEventListener('DOMContentLoaded', apply);

  // Cart re-renders: the theme dispatches cart:refresh on some paths; a body observer
  // catches the rest (drawer open, quantity change, section swaps). apply() only writes
  // when the src actually differs, so the observer self-terminates each cycle.
  document.addEventListener('cart:refresh', schedule);
  try {
    new MutationObserver(schedule).observe(document.body || document.documentElement, {
      childList: true,
      subtree: true,
    });
  } catch (e) {}
})();
